import type * as stylex from '@stylexjs/stylex';
import { createLink } from '@tanstack/react-router';

import { LinkButton, type LinkButtonProps } from '@/libs/serenity-ui';

// createLink somehow affects the style property, so we need to use a custom property to pass the style property to the component.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const RouterButtonLink = createLink(({ className, ...props }: Omit<LinkButtonProps, 'style'> & { className?: string, _style?: stylex.StyleXStyles }) => <LinkButton {...props} style={props._style} />);
